<template>
  <p :class="{ isPc: !isSp, isSp: isSp }" class="termsAndPolicyArea"><KiyakuAnchor />及び<PrivacyPolicyAnchor /></p>
</template>

<script>
export default {
  name: 'TermsAndPolicy',
  components: {
    KiyakuAnchor: { template: '#kiyakuAnchor' },
    PrivacyPolicyAnchor: { template: '#privacyPolicyAnchor' },
  },
  props: {
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.termsAndPolicyArea {
  text-align: center;
  font-size: $text-size-paragraph2;
  line-height: $text-line-height-default;

  &.isPc {
    padding-left: 27px;
  }

  a {
    color: $color-text-link;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  &.isSp {
    // アクション時に発火してしまうので対処
    a:hover {
      text-decoration: none;
    }
  }
}
</style>
